"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _ToggleIcon = require("./ToggleIcon.styled");
var ToggleIcon = exports.ToggleIcon = function ToggleIcon(_ref) {
  var testId = _ref.testId,
    screenReaderText = _ref.screenReaderText,
    active = _ref.active,
    onClick = _ref.onClick,
    activeIcon = _ref.activeIcon,
    inactiveIcon = _ref.inactiveIcon,
    className = _ref.className,
    iconColor = _ref.iconColor,
    enableFeature = _ref.enableFeature,
    id = _ref.id,
    ariaPressed = _ref.ariaPressed,
    ddActionName = _ref.ddActionName;
  var faIconColor = iconColor ? iconColor : active ? '#494e69' : '#fff';
  return _react["default"].createElement(_ToggleIcon.StyledSpan, {
    id: id,
    className: className,
    "data-testid": testId,
    onClick: onClick,
    enableFeature: enableFeature === undefined ? true : enableFeature,
    "aria-pressed": ariaPressed,
    role: "button",
    "data-dd-action-name": ddActionName
  }, _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: active ? activeIcon : inactiveIcon,
    color: faIconColor
  }), _react["default"].createElement("span", {
    className: "visually-hidden"
  }, screenReaderText));
};
ToggleIcon.propTypes = {
  testId: _propTypes["default"].string,
  screenReaderText: _propTypes["default"].string,
  active: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  activeIcon: _propTypes["default"].object,
  inactiveIcon: _propTypes["default"].object,
  className: _propTypes["default"].string,
  iconColor: _propTypes["default"].string,
  enableFeature: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  ariaPressed: _propTypes["default"].string,
  ddActionName: _propTypes["default"].string
};